import { useMemo } from "react";
import { useGroupProvider } from "@/context/group-provider";

export const CSR_TEAM_NAME_FALLBACK = "CSR";

/**
 * First and last initials of a team name:
 * "Zakipoint Health CSR" -> "ZC", "Support" -> "S".
 */
export const getTeamInitials = (teamName: string): string => {
  const words = teamName.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";
  if (words.length === 1) return words[0][0];
  return words[0][0] + words[words.length - 1][0];
};

/** The CSR team's display name and avatar initials, from the current group. */
const useCsrTeam = () => {
  const { groupData } = useGroupProvider();
  const csrTeamName = groupData?.csrTeamName?.trim() || CSR_TEAM_NAME_FALLBACK;

  return useMemo(
    () => ({ csrTeamName, csrInitials: getTeamInitials(csrTeamName) }),
    [csrTeamName],
  );
};

export default useCsrTeam;
